import React, { useEffect } from 'react';
import TubesCursor from "tubes1.min.js";
import './App.css';

// --- Inline SVG Icons ---
const TerminalIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
);

const ShieldIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
);

const MicroscopeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 18h8"></path><path d="M14 10l-9.453 5.394a1 1 0 0 0-.547.856V18h16a1 1 0 0 0 1-1v-4.5a2 2 0 0 0-2-2H14z"></path><path d="M16 11V5.5L12.5 2 9 5.5V11"></path><circle cx="12.5" cy="5.5" r="1.5"></circle></svg>
);

// --- Lab Card Component ---
const LabCard = ({ lab, onClick }) => {
  const IconComponent = lab.icon;
  return (
    <div onClick={() => onClick(lab)} className="lab-card">
      <IconComponent className="card-icon" />
      <h2 className="card-title">{lab.title}</h2>
      <h3 className="card-subtitle">{lab.subtitle || 'Simulated Environment'}</h3>
      <span className="card-link">Explore Lab →</span>
    </div>
  );
};

// --- Lab Data ---
const LAB_DATA = [
  {
    id: 'pentest',
    title: 'Cookie',
    icon: TerminalIcon,
    labUrl: 'https://cookie.wrtxlab.redfoxsec.com/',
    description: "Engage in hands-on penetration testing labs covering network, web application, and cloud security..."
  },
  {
    id: 'dfir',
    title: 'Local',
    icon: ShieldIcon,
    labUrl: 'https://local.wrtxlab.redfoxsec.com/',
    description: "Simulate a real-world security incident, from initial alert to final reporting..."
  },
  {
    id: 'malware',
    title: 'Validate',
    icon: MicroscopeIcon,
    labUrl: 'https://validate.wrtxlab.redfoxsec.com/',
    description: "Dive deep into malicious code. Use static and dynamic analysis techniques..."
  },
];

// --- HomeView Component ---
const HomeView = ({ onLabClick }) => (
  <main className="main-content">
    <h1 className="page-title">
      <span className="logo-highlight">WRTX</span> Evilginx Lab
    </h1>

    <section className="lab-cards-grid">
      {LAB_DATA.map((lab) => (
        <LabCard key={lab.id} lab={lab} onClick={onLabClick} />
      ))}
    </section>
  </main>
);

// --- Main App Component ---
const App = () => {

  const handleLabClick = (lab) => {
    if (lab.labUrl) window.open(lab.labUrl, '_blank');
  };

  return (
  <div className="app-container">
    {/* Custom 3D Cursor Canvas */}
    <canvas id="canvas"></canvas>   {/* <--- must be a real canvas */}

    <div className="hero">
      {/* <header className="header">
        <div className="header-content">
          <div className="logo-section">
            <ShieldIcon className="logo-icon" />
            <span className="logo-text">
              RedFox<span className="logo-highlight">Labs</span>
            </span>
          </div>
        </div>
      </header> */}

      <HomeView onLabClick={handleLabClick} />

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} RedFoxSec Labs Inc. | All rights reserved.</p>
      </footer>
    </div>
  </div>
);

};

export default App;
